import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { OfferletterviewComponent } from '../elcm/offerletterview/offerletterview.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SharedService } from 'src/app/service/shared/shared.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { ElcmGenericServiceService } from '../_elcm-services/elcm-generic-service.service';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';

@Component({
  selector: 'app-elcm-appoinment-letter-report',
  templateUrl: './elcm-appoinment-letter-report.component.html',
  styleUrls: ['./elcm-appoinment-letter-report.component.scss'],
})
export class ElcmAppoinmentLetterReportComponent implements OnInit {
  yearList: any[] = [];
  selectedYear: any;
  buttonColorName: any;
  loggedInUserCompanyID: any;
  incrementId: any;
  loggedInUserRole: any;
  loggedInUserId: any;
  getIncrementFyYearList: any[] = [];
  fromYear: any;
  toYear: any;
  dropdownSettings: IDropdownSettings = {};
  selectedDepartment: any;

  selectedManager: any;
  selectedEmployeeForFilter: any;
  selectedRating: any;
  managerId: any;
  employeeId: any;
  searchAppoinmentTableData: any;
  loggedInCompanyFiscalyear: any;
  getIncrementInputYear: any[] = [];
  companyYears: any[] = [];
  getDepartmentsList: any[] = [];

  getManagerList: any[] = [];
  getEmployeeList: any[] = [];
  getSelectedRating: any[] = [];
  getRatingData: any[] = [];
  isShowDownloadBtn: boolean = false;
  selectAllChecked: boolean = false;

  incrementLetterData: any[] = [];
  filteredIncrementLetterData: any = [];
  subModuleButtonColor: any;

  constructor(private route: Router, private httpService: HttpService, private config: Config,
    private encryptionService: EncryptionService, public dialog: MatDialog, public sharedService: SharedService,
    private http: HttpClient, private elcmGenericService: ElcmGenericServiceService, public mobileResponsiveService: MobileResponsiveService) { }

  ngOnInit() {

    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    // this.loggedInUserRole = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.getpmsyearlist();
    // this.getEmployeeListForAppoinmentleter();
  }

  pmsYears: any = []
//   getpmsyearlist() {
//     this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
//       this.pmsYears = [];

//       data?.data?.yearRanges?.forEach((ele: any) => {
//         var test = ele.split('_');
//         let obj = {
//           year: test[0] + '-' + test[1]
//         };

//         // Get current year
//         const currentYear = new Date().getFullYear();

//         // Ensure only past and current years are included
//         var yearParts = obj.year.split('-');
//         let fromYear = parseInt(yearParts[0]);
//         let toYear = parseInt(yearParts[1]);

//         // Add to pmsYears only if it's not a future year
//         if (toYear <= currentYear) {
//           this.pmsYears.push(obj);
//         }
//       });

//       // Iterate over the years and set the selected year for various fields
//       this.pmsYears?.forEach((ele: any) => {
//         const currentYear = new Date().getFullYear();
//         let yearValue = '';
//         if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {

//           yearValue = `${currentYear}-${currentYear}`; // Calendar year
//         } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {

//           if (new Date().getMonth() < 3) {
//             // If it's Jan, Feb, or Mar, we're in the previous fiscal year
//             yearValue = `${currentYear - 1}-${currentYear}`;
//           } else {
//             // From Apr onwards, it's the current fiscal year
//             yearValue = `${currentYear}-${currentYear + 1}`;
//           }
//         }

//         if (ele?.year == yearValue) {
//           console.log("dgmfdgl");

//           this.selectedYear = ele?.year;

//  this.getEmployeeListForAppoinmentleter();


//         }


//       });
//     })
//   }


  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
  
      this.setSelectedYear(yearValue);
    // Additional function calls
    this.getEmployeeListForAppoinmentleter();
    });
  }
setSelectedYear(yearValue: string): void {
  const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
  if (selectedYearObj) {
    this.selectedYear = selectedYearObj?.year;
    let test = selectedYearObj?.year.split('-');
       
  }
}
  onYearChange(event: any) {
    console.log(event);
    this.selectedYear = event;
    this.selectedEmployeeForFilter=[];
    this.selectedDepartment=[];
    this.getEmployeeListForAppoinmentleter();
  }



  // Event handlers
  onSelectYear(event: any) {
    console.log("Selected Year:", event);
  }

  onDeSelectYear(event: any) {
    console.log("Deselected Year:", event);
  }

  selectAllYears(event: any) {
    console.log("All Years Selected:", event);
  }

  onDeSelectAllYears() {
    console.log("All Years Deselected");
  }

  onSelectDepartment() {
    if (this.selectedDepartment.length > 0) {
      this.filterDepartMentList();
    }
  }

  onDeSelectDepartment() {
    this.filterDepartMentList();
  }



  selectAllDepartment(items: any): void {
    this.selectedDepartment = items;
    this.filterDepartMentList();
  }

  onDeSelectAllDepartment() {
    this.selectedDepartment = [];
    this.filterDepartMentList();
  }


  onSelectdEmp() {
    if (this.selectedEmployeeForFilter.length > 0) {
      this.filterEmployeeList();
    }
  }

  onDeSelectdEmployee() {
    this.filterEmployeeList();
  }

  selectAllEmployee(items: any): void {
    this.selectedEmployeeForFilter = items;
    this.filterEmployeeList();
  }

  onDeSelectAllEmployee() {
    this.selectedEmployeeForFilter = [];
    this.filterEmployeeList();

  }

  filterEmployeeList() {

    if (this.selectedEmployeeForFilter.length > 0) {
      let findId = this.selectedEmployeeForFilter.map((elm: any) => elm.id);
      let employee = this.appoinmentLetterData.filter((elm: any) => findId.includes(elm.candidateId));
      this.appoinmentLetterDataforTable = employee
    } else {
      if (this.selectedDepartment.length > 0) {
        let findId = this.selectedDepartment.map((elm: any) => elm.id.trim().toLowerCase());
        let employee = this.appoinmentLetterData.filter((elm: any) =>
          elm.department && findId.includes(elm.department.trim().toLowerCase()) // Normalize and check
        );
        this.appoinmentLetterDataforTable = employee;
      } else {

        this.appoinmentLetterDataforTable = this.appoinmentLetterData;
      }
    }
  }

  filterDepartMentList() {
    if (this.selectedDepartment.length > 0) {

      let findId = this.selectedDepartment.map((elm: any) => elm.id.trim().toLowerCase());
      console.log(findId);
      console.log(this.appoinmentLetterData);
      let employee = this.appoinmentLetterData.filter((elm: any) =>
        elm.department && findId.includes(elm.department.trim().toLowerCase()) // Normalize and check
      );
      console.log(employee);

      this.appoinmentLetterDataforTable = employee;
      this.getEmployeeList = [];
      employee.forEach((elm: any) => {
        if (!this.getEmployeeList.some((candidate: any) => candidate.candidateId === elm.candidateId)) {

          this.getEmployeeList.push({
            id: elm.candidateId,
            name: elm.firstName + " " + elm.lastName
          })
        }
      })
    } else {
      this.appoinmentLetterDataforTable = this.appoinmentLetterData;
      this.appoinmentLetterData.forEach((elm: any) => {
        if (!this.getEmployeeList.some((candidate: any) => candidate.candidateId === elm.candidateId)) {

          this.getEmployeeList.push({
            id: elm.candidateId,
            name: elm.firstName + " " + elm.lastName
          })
        }
      })
    }
  }

  // Rating

  getRatingListByEmployee() {
    const employeeId = this.getEmployeeList.map((ele: any) => ele.id)
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear,
      "userId": employeeId
    }

  }





  debounceTimer: any;
  appoinmentReportSearch() {
    console.log(this.searchAppoinmentTableData
    );

    // If search is empty, reset to original data
    if (!this.searchAppoinmentTableData
      || this.searchAppoinmentTableData
        .trim() === '') {
      console.log("Inside if - Resetting data");
      this.appoinmentLetterDataforTable

        = [...this.appoinmentLetterData]; // Reset data
      return;
    }

    // Convert search text to lowercase for case-insensitive comparison
    const searchTextLower = this.searchAppoinmentTableData
      .toLowerCase().trim();

    // Filter appointment data based on search term
    this.appoinmentLetterDataforTable = this.appoinmentLetterData.filter((employee: any) =>
      Object.values(employee).some(value => {
        if (value === null || value === undefined) return false; // Skip null/undefined values
        return value.toString().toLowerCase().includes(searchTextLower);
      })
    );

    console.log("Filtered Data:", this.appoinmentLetterDataforTable

    );
  }


  allSelectedData: any = []
  toggleSelectAll() {
    this.appoinmentLetterDataforTable

      .forEach((item: any) => item.isChecked = this.selectAllChecked);

    this.allSelectedData = this.appoinmentLetterDataforTable


    this.isShowDownloadBtn = this.selectAllChecked; // Show download if all are selected

  }
  appoinmentlettterDataForSingleSelection: any = []
  checkedEmployees: any = []
  onCheckboxChange(event: MatCheckboxChange, employee: any) {
    if (event.checked) {
      // Add employee to the checked list if checked
      this.checkedEmployees.push(employee);
    } else {
      // Remove employee from checked list if unchecked
      this.checkedEmployees = this.checkedEmployees.filter((elm: any) => elm.candidateId !== employee.candidateId);
    }

    console.log("Checked Employees:", this.checkedEmployees);

    // Update appointment letter data to show only checked employees
    this.appoinmentlettterDataForSingleSelection = [...this.checkedEmployees];
    console.log(this.appoinmentlettterDataForSingleSelection);

    const allChecked = this.appoinmentLetterDataforTable

      .every((item: any) => item.isChecked);
    const anyChecked = this.appoinmentLetterDataforTable

      .some((item: any) => item.isChecked);
    console.log(anyChecked);

    this.selectAllChecked = allChecked; // Update 'Select All' state
    this.isShowDownloadBtn = anyChecked; // Show download button if at least one is checked
  }
  downloadSelected() {
    const selectedIds = this?.appoinmentLetterDataforTable


      ?.filter((data: any) => data.isChecked)
      .map((data: any) => data.candidateId);

    if (!selectedIds || selectedIds.length === 0) {
      console.warn("No items selected for download.");
      return;
    }

    if (this.selectAllChecked) {
      console.log(this.allSelectedData);


      this.allSelectedData = this.appoinmentlettterDataForSingleSelection.length > 0 ? this.appoinmentlettterDataForSingleSelection : this.allSelectedData;
      this.allSelectedData.forEach((elm: any) => {
        this.viewDocument(elm.appointmentLetterFileName);
      })
    } else {
      if (!this.appoinmentlettterDataForSingleSelection) {
        console.error("Download URL is not defined.");
        return;
      }
      // const fileName = this.appoinmentlettterData.split('/').pop() || "downloaded-file";
      this.appoinmentlettterDataForSingleSelection.forEach((elm: any) => {
        this.viewDocument(elm.appointmentLetterFileName);
      })
    }

  }

  viewDocument(fileUrl: string): void {

    if (fileUrl) {
      // Open the document in a new tab
      fileUrl = `${this.config.downloadFile}${this.loggedInUserCompanyID}/${fileUrl}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }
  }
  onClickPreviewLetter(userName: any, userId: any, fileName: any) {
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.height = '100%';
    // dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      userName: userName,
      userId: userId,
      fileName: fileName,
      incrementLetterData: this.incrementLetterData // Pass the full data here
    };
    dialogConfig.panelClass = 'phi_mdc_dialog__container_100';
    const dialogRef = this.dialog.open(OfferletterviewComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => { });
  }


  filteredEmployees: any = [];
  employees: any = [];
  appoinmentLetterDataforTable: any = []
  appoinmentLetterData: any = []
  getEmployeeListForAppoinmentleter() {
    // this.httpService.callGetService(`${this.config.employeeList}/${this.loggedInUserCompanyID}`).subscribe((record: any) => {
    this.httpService.callGetService(`${this.config.getListbyCandidateIdAndCompanyId}?companyId=${this.loggedInUserCompanyID}`).subscribe((record: any) => {
      this.filteredEmployees = record.data.candidate.filter((elm:any)=>elm.year==this.selectedYear);

      if (this.loggedInUserRole == 'Admin') this.filteredEmployees = this.elcmGenericService.empFilterForAllEmployeeList(this.filteredEmployees, +this.loggedInUserId, 'hrId', true);

      this.employees = this.filteredEmployees.filter(
        (elm: any) => elm.status === 'APPROVED_APPOINTMENT_LETTER'
      ); // Initialize filtered list

      this.appoinmentLetterDataforTable = this.employees.map((elm: any) => {
        // Find all records that match by candidateId
        let matchData = record.data.currentEmploymentFormByHR.filter(
          (rec: any) => rec.candidateId === elm.candidateId&&elm.year==this.selectedYear
        );

        return {
          ...elm,
        
          department: matchData.length > 0
            ? matchData.map((item: any) => item.department).join(', ')  // Convert to string
            : null, // If no match, return null
          isChecked: false
        };
      });

        this.appoinmentLetterData = this.employees.map((elm: any) => {
        // Find all records that match by candidateId
        let matchData = record.data.currentEmploymentFormByHR.filter(
          (rec: any) => rec.candidateId === elm.candidateId &&elm.year==this.selectedYear
        );

        return {
          ...elm,
          // If there are multiple matches, join departments into a string or store as an array
          department: matchData.length > 0
            ? matchData.map((item: any) => item.department).join(', ')  // Convert to string
            : null, // If no match, return null
          isChecked: false
        };
      });
      this.getEmployeeList = []
      
      this.appoinmentLetterData.forEach((elm: any) => {
        if (!this.getEmployeeList.some((candidate: any) => candidate.candidateId === elm.candidateId)) {

          this.getEmployeeList.push({
            id: elm.candidateId,
            name: elm.firstName + " " + elm.lastName
          })
        }
      })
      this.getDepartmentsList=[]
      this.appoinmentLetterData.forEach((elm: any) => {
        const deptName = elm.department?.trim().toLowerCase(); // Normalize department name

        if (!this.getDepartmentsList.some((candidate: any) => candidate.name.toLowerCase() === deptName)) {
          this.getDepartmentsList.push({
            id: deptName,
            name: elm.department.trim() // Keep original formatting for display
          });
        }
      });


    })
  }

  // ------------------------------------------------------------------------ Probation offer and appointment report----------------------------------------------------------------



}
